import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TdLoadingService } from '@covalent/core';

import { AbstractIdeaList } from '../../shared/abstract-idea-list';
import { IdeaService } from '../../services/idea.service';
import { AdminService } from '../../services/admin/admin.service';
import { PetitionAdminConfigs } from '../../shared/admin-models/interfaces/petition-admin-configs.interface';

@Component({
  selector: 'app-idea-list',
  templateUrl: './idea-list.component.html',
  styleUrls: ['./idea-list.component.scss']
})
export class IdeaListComponent extends AbstractIdeaList {
  signersNeededAmount: number;

  /**
   * Constructor
   *
   * @param _activatedRoute
   * @param _loadingService
   * @param _ideaService
   */
  constructor(
    protected _activatedRoute: ActivatedRoute,
    protected _loadingService: TdLoadingService,
    protected _ideaService: IdeaService,
    private adminService: AdminService
  ) {
    super(_activatedRoute, _loadingService, _ideaService);
  }

  /**
   * Init
   */
  ngOnInit() {
    this._subs.add(
      this._activatedRoute.queryParams.subscribe((params) => {
        const { categoryId } = params;

        this.searchParams = Object.assign(this.searchParams, { categoryId });

        this._getAllIdeas();
      })
    );
    this.getconfigs();
  }
  getconfigs(): void {
    this.adminService.getConfigs().subscribe((res: PetitionAdminConfigs) => {
      this.signersNeededAmount = res.petitionCounterValue;
    });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/idea-list/idea-list.component.ts